import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { HelpIndex, Endpoint, MessageType, UpdateStatusType, LoadFileType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { ConnectorPickerComponent } from '../../connector-picker/connector-picker.component';
import { NewDataSetLoadFileMenuComponent } from '../../new-data-set-load-file-menu/new-data-set-load-file-menu.component';
import * as _ from 'underscore';
import { IndexLevel } from '../../../models/index-settings';

@Component({
    standalone: false,
    selector: 'res-new-load-file-modal',
    templateUrl: './new-load-file-modal.component.html',
    styleUrls: ['./new-load-file-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NewLoadFileModalComponent extends BaseModalComponent {
    @ViewChild(ConnectorPickerComponent, { static: true }) connectorPicker: ConnectorPickerComponent;
    @ViewChild(NewDataSetLoadFileMenuComponent, { static: true }) menuComponent: NewDataSetLoadFileMenuComponent;

    indexLevels = [
        { type: IndexLevel.DO_NOT_INDEX, name: 'Do Not Index' },
        { type: IndexLevel.SYSTEM_METADATA, name: 'System Metadata' },
        { type: IndexLevel.FILE_METADATA, name: 'File Metadata' },
        { type: IndexLevel.CONTENT, name: 'Content' },
        { type: IndexLevel.ANALYTIC, name: 'Analytic' },
    ];

    // modal information
    modalTitle = 'New Data Set from Load File';
    modalAutomationId = 'new-data-set';
    verifyRequiredValidator = true;
    primaryButtonLabel = 'Create Data Set';
    secondaryButtonLabel = 'Cancel';
    isBusy = false;
    modalHelpIndex = HelpIndex.imports_add_load_file_dlg;
    isBusyMessage = 'Loading ...';
    modalClass = 'new-load-file';

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    getConnector(data) {
        if (data) {
            this.commonService.sendMessage(MessageType.connectorChanged, {
                connector: data.connector, paths: data.paths
            });
        }
    }

    getPath(path) {
        this.commonService.sendMessage(MessageType.loadFilePathChanged, { filePath: path });
    }

    ok() {
        this.isBusy = true;
        const loadFileName = this.connectorPicker.selectedFile.name;
        this.restService.post(Endpoint.orgManager_createDataArea, {
            connectorHandle: this.connectorPicker.selectedConnector.handle,
            description: this.menuComponent.nameDescriptionComponent.description,
            mode: 'IMPORT',
            name: this.menuComponent.nameDescriptionComponent.name + '_' + loadFileName,
            path: this.connectorPicker.currentSelectedPath,
            skippedDirectories: []
        }).then(response => {
            this.restService.post(Endpoint.orgManager_createCorpus, {
                attributes: [{ name: 'projecthandle', value: this.commonService.currentProject.handle }],
                brand: true,
                dataAreaHandles: [response.dataArea.handle],
                description: this.menuComponent.nameDescriptionComponent.description,
                loadFileName: loadFileName,
                loadFileType: loadFileName.endsWith('.xml') ? LoadFileType.EDRM_XML : LoadFileType.CONCORDANCE_DAT,
                loadFileProfileId: this.menuComponent.selectedLoadFileProfileId,
                name: this.menuComponent.nameDescriptionComponent.name
            }).then(corpusResponse => {
                this.closeModal(true, { name: this.menuComponent.nameDescriptionComponent.name, entityType: UpdateStatusType.CORPUS });

                this.restService.post(Endpoint.projectManager_listCorpusSets, {
                    projectHandle: this.commonService.currentProject.handle,
                    count: 1,
                    startIndex: 0
                }).then(listCorpusSetsResponse => {
                    this.restService.post(Endpoint.corpusSetManager_addCorpus, {
                        corpusHandle: corpusResponse.corpus.handle,
                        corpusSetHandle: listCorpusSetsResponse.corpusSets[0].handle
                    }).then(addCorpusResponse => {
                        const currentIndexValue = _.findWhere(this.indexLevels, { type: this.menuComponent.indexLevelType });
                        const scanAttributes = this.menuComponent.setAttributes;
                        if (scanAttributes) {
                            scanAttributes.push({ name: 'batchNumber', value: this.menuComponent.batchName?.trim() });
                            scanAttributes.push({ name: 'projecthandle', value: this.commonService.currentProject.handle });
                        }
                        this.restService.post(Endpoint.corpusManager_createRepresentation, {
                            attributes: [{ name: 'projecthandle', value: this.commonService.currentProject.handle }],
                            corpusHandle: corpusResponse.corpus.handle,
                            scanAttributes: scanAttributes ? scanAttributes : null,
                            taskDescription: 'Creating representation ' + currentIndexValue.name + ' Index for ' + this.menuComponent.nameDescriptionComponent.name,
                            typeList: ['CONTENT_INDEX', 'VECTOR_SET'],
                            enablePatternDetection: this.menuComponent.isPatternDetectionEnabled
                        }).then(res => {
                            this.isBusy = false;
                            this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.CORPUS);
                        }, () => {
                            this.isBusy = false;
                        });
                    });
                });
            }, () => {
                this.isBusy = false;
            });
        }, () => {
            this.isBusy = false;
        });
    }

    isPrimaryButtonEnabled() {
        return this.connectorPicker.selectedConnector && this.connectorPicker.selectedFile && this.connectorPicker.selectedFile.handle
            && this.connectorPicker.selectedFile.handle.length > 0 && this.menuComponent.selectedLoadFileProfileId && !this.isBusy &&
            this.menuComponent.nameDescriptionComponent && this.menuComponent.nameDescriptionComponent.name && this.menuComponent.nameDescriptionComponent.name.length > 0;
    }

}
